/* eslint-disable @typescript-eslint/no-explicit-any */
import Screen from "@/src/components/Screen";
import { Card } from "@/src/components/shad/card";
import Offers from "./components/Offers";
import { Tabs, TabsList, TabsTrigger } from "@/src/components/shad/tabs";
import api from "@/src/utils";
import apiRoutes from "@/src/apiRoutes";
import { useQuery } from "@tanstack/react-query";
import { P2PComponentsData } from "./types";
import AppendInput from "@/src/components/PhoneInput/AppendInput";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/src/components/shad/select";
import { Button } from "@/src/components/Button/Button";
import { Check, ChevronDown, Filter, PlusIcon, RotateCw } from "lucide-react";
import { Modal } from "@/src/components/Modal/Modal";
import { useMediaQuery } from "usehooks-ts";
import { NavLink } from "react-router-dom";
import { cn } from "@/lib/utils";
import { Label, textVariants } from "@/src/components/Text/Text";
import myoffer from "@assets/myoffer.svg";
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
} from "@components/shad/command";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@components/shad/popover";
import { isEmpty } from "lodash";
import { useTranslation } from "react-i18next";
import { parseAsArrayOf, parseAsInteger, useQueryState } from "nuqs";

const P2pTrade = () => {
  const { t } = useTranslation();
  const trans = (key: string) => t(`app.p2p.${key}`);
  // const [openFilter, setOpenFilter] = useUrlState("filter");
  const [openFilter, setOpenFilter] = useQueryState("filter");
  const isSmallDevice = useMediaQuery("(max-width: 768px)");
  // const [filters, setFilters] = useState<Filters>({
  //   coin__id: undefined,
  //   offer_type: "sell",
  //   currency: undefined,
  //   trading_amount__gte: undefined,
  //   payment_methods: undefined,
  // });
  const [coin, setCoin] = useQueryState("coin", {
    parse: Number,
  });
  const [offerType, setOfferType] = useQueryState("offerType", {
    defaultValue: "sell",
  });
  const [currency, setCurrency] = useQueryState("currency");
  const [tradingAmount, setTradingAmount] = useQueryState("tradingAmount", {
    parse: Number,
  });
  const [paymentMethods, setPaymentMethods] = useQueryState(
    "paymentMethods",
    parseAsArrayOf(parseAsInteger)
  );

  const fetchP2pComponents = async () => {
    const res = await api.get(apiRoutes.fetchP2pComponents);
    return res.data;
  };

  const { data } = useQuery<P2PComponentsData>({
    queryKey: ["fetch_p2p_components"],
    queryFn: fetchP2pComponents,
  });

  function refresh() {
    setCurrency("");
    setCoin(null);
    setOfferType("sell");
    setTradingAmount(0);
    setPaymentMethods(null);
    setOpenFilter("");
  }
  return (
    <>
      <div className="bg-white border-b border-gray-100 dark:bg-grey-600 dark:border-grey-500 px-3 md:p-0">
        <div className="py-3 max-w-screen-xl mx-auto md:px-4 flex items-center justify-between">
          <div className="flex items-center space-x-6">
            <div className="flex items-center gap-1">
              <img className="h-5 w-5" src={myoffer} alt="guide" />
              <NavLink
                to="/app/trade/myoffers"
                className={({ isActive }) =>
                  cn(
                    textVariants({ variant: "desc" }),
                    isActive && "font-semibold text-black dark:text-white",
                    "cursor-pointer"
                  )
                }
              >
                {trans("nav.myAds")}
              </NavLink>
            </div>
            <div className="flex items-center gap-1">
              <PlusIcon className="h-4 w-4 dark:text-white" />
              <NavLink
                to="/app/trade/create"
                className={({ isActive }) =>
                  cn(
                    textVariants({ variant: "desc" }),
                    isActive && "font-semibold text-black dark:text-white",
                    "cursor-pointer"
                  )
                }
              >
                {trans("nav.createAd")}
              </NavLink>
            </div>
          </div>
        </div>
      </div>
      <Screen>
        <Card>
          <div className="border-b border-gray-100 dark:border-grey-500 p-6 hidden md:flex items-center gap-5">
            <div className="w-full flex md:flex-row flex-col justify-between items-center">
              <div className="flex items-center gap-5">
                <Tabs
                  defaultValue={offerType as string}
                  onValueChange={(val) =>
                    // setFilters({ ...filters, offer_type: val })
                    setOfferType(val)
                  }
                >
                  <TabsList>
                    <TabsTrigger
                      className="data-[state=active]:bg-[#56BFA0] data-[state=active]:text-white"
                      value="sell"
                    >
                      {trans("ads.table.buttons.buy")}
                    </TabsTrigger>
                    <TabsTrigger
                      className="data-[state=active]:bg-red-400 data-[state=active]:text-white"
                      value="buy"
                    >
                      {trans("ads.table.buttons.sell")}
                    </TabsTrigger>
                  </TabsList>
                </Tabs>
                <Select
                  onValueChange={(val) =>
                    // setFilters({ ...filters, coin__id: Number(val) })
                    setCoin(Number(val))
                  }
                >
                  <SelectTrigger>
                    <SelectValue placeholder={trans("filters.coin")} />
                  </SelectTrigger>
                  <SelectContent>
                    {data?.info?.coins.map((coin) => (
                      <SelectItem key={coin?.id} value={coin?.id.toString()}>
                        <div className="flex items-center gap-1">
                          <img src={coin?.image} className="h-4 w-4" />{" "}
                          <span className="uppercase">{coin?.ticker}</span>
                        </div>
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </div>
              <div className="flex items-center gap-5">
                <AppendInput
                  placeholder={trans("filters.amount")}
                  value={tradingAmount?.toString()}
                  onChange={(e) => [setTradingAmount(Number(e.target.value))]}
                />
                <Select
                  value={(currency as string) ?? undefined}
                  onValueChange={(val) => {
                    [setCurrency(val)];
                  }}
                >
                  <SelectTrigger>
                    <SelectValue placeholder={trans("filters.currency")} />
                  </SelectTrigger>
                  <SelectContent>
                    {data?.info?.currencies.map((curr, index) => (
                      <SelectItem
                        key={index}
                        value={curr?.currency + curr?.id.toString()}
                      >
                        <div className="flex items-center gap-1">
                          <img src={curr?.image} alt="" className="h-4 w-4" />{" "}
                          <span>{curr?.currency}</span>
                        </div>
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
                <Popover>
                  <div className=" grid ">
                    <PopoverTrigger asChild>
                      <Button
                        role="combobox"
                        className={cn(
                          "focus:outline-indigo-400 dark:focus:outline-grey-400 focus:outline-none dark:bg-grey-600 bg-input-field text-black dark:text-white dark:placeholder:text-gray-200 w-full border py-2"
                        )}
                      >
                        {isEmpty(paymentMethods) ? (
                          <span className="flex  w-full gap-2 whitespace-nowrap text-gray-400">
                            {trans("filters.paymentMethods")}
                          </span>
                        ) : (
                          <span className="flex  w-full gap-2 whitespace-nowrap text-gray-400">
                            {`${paymentMethods?.length} Selected`}
                          </span>
                        )}
                        <ChevronDown className="ml-2 h-4 w-4 shrink-0 opacity-50 " />
                      </Button>
                    </PopoverTrigger>
                    <PopoverContent
                      className={cn(
                        ` max-h-[--radix-popover-content-available-height] overflow-y-scroll p-0 min-w-[var(--radix-popover-trigger-width)]  z-[100] `
                      )}
                      align="start"
                    >
                      <Command>
                        <CommandInput placeholder={`Search payments`} />
                        <CommandEmpty>Nothing found.</CommandEmpty>
                        <CommandGroup>
                          {data?.info?.payment_methods.map((item, index) => (
                            <CommandItem
                              key={index}
                              onSelect={() => {
                                if (
                                  paymentMethods &&
                                  paymentMethods?.length >= 1
                                ) {
                                  if (paymentMethods?.includes(item?.id)) {
                                    setPaymentMethods(
                                      (prev) =>
                                        prev?.filter(
                                          (i) => i !== item?.id
                                        ) as number[]
                                    );
                                  } else {
                                    setPaymentMethods((prev) => [
                                      ...(prev as number[]),
                                      item?.id,
                                    ]);
                                  }
                                } else {
                                  setPaymentMethods([item?.id]);
                                }
                              }}
                              value={item?.name}
                            >
                              <Check
                                className={cn(
                                  "mr-2 h-4 w-4",
                                  paymentMethods?.some((i) => i === item?.id)
                                    ? "opacity-100"
                                    : "opacity-0"
                                )}
                              />

                              <div className="flex items-center h-1">
                                <span className="text-lg mr-2">
                                  <img
                                    src={item?.image}
                                    alt=""
                                    className="h-5 w-5"
                                  />
                                </span>
                                <span>{item?.name}</span>
                              </div>
                            </CommandItem>
                          ))}
                        </CommandGroup>
                      </Command>
                    </PopoverContent>
                  </div>
                </Popover>
                <Button
                  onClick={refresh}
                  className="bg-[#F6F8FF] whitespace-nowrap border border-gray-200 text-gray-500 flex items-center gap-1"
                >
                  {trans("filters.clearFilters")}{" "}
                  <RotateCw className="h-4 w-4 text-gray-500" />
                </Button>
              </div>
            </div>
          </div>
          <div className="px-4 pt-4 flex justify-between items-center md:hidden">
            <Tabs
              defaultValue={offerType}
              onValueChange={(val) =>
                // setFilters({ ...filters, offer_type: val })
                setOfferType(val)
              }
            >
              <TabsList>
                <TabsTrigger
                  className="data-[state=active]:bg-[#56BFA0] data-[state=active]:text-white"
                  value="sell"
                >
                  {trans("ads.table.buttons.buy")}
                </TabsTrigger>
                <TabsTrigger
                  className="data-[state=active]:bg-red-400 data-[state=active]:text-white"
                  value="buy"
                >
                  {trans("ads.table.buttons.sell")}
                </TabsTrigger>
              </TabsList>
            </Tabs>
            <Button
              onClick={() => setOpenFilter("open")}
              className="flex items-center gap-1.5 font-normal text-gray-500"
              variant={"ghost"}
            >
              <Filter className="h-4 w-4 text-gray-500" /> Filter
            </Button>
          </div>
          <div className="md:p-6 p-4">
            <Offers />
          </div>
        </Card>
        {isSmallDevice && (
          <Modal
            open={openFilter === "open"}
            setOpen={(val) => setOpenFilter(val ? null : "open")}
          >
            <div className="w-full grid gap-3 ">
              <div>
                <Label>{trans("filters.coin")} </Label>
                <Select
                  value={coin?.toString()}
                  onValueChange={(val) => {
                    setCoin(Number(val));
                  }}
                >
                  <SelectTrigger>
                    <SelectValue placeholder={trans("filters.coin")} />
                  </SelectTrigger>
                  <SelectContent>
                    {data?.info?.coins.map((coin) => (
                      <SelectItem key={coin?.id} value={coin?.id.toString()}>
                        <div className="flex items-center gap-1">
                          <img src={coin?.image} className="h-4 w-4" />{" "}
                          <span className="uppercase">{coin?.ticker}</span>
                        </div>
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </div>

              <AppendInput
                label={trans("filters.amount")}
                type="number"
                // value={minAmount}
                value={tradingAmount?.toString()}
                // onChange={(e) => setMinAmount(Number(e.target.value))}
                onChange={(e) =>
                  // setFilters({
                  //   ...filters,
                  //   trading_amount__gte: Number(e.target.value),
                  // })
                  setTradingAmount(Number(e.target.value))
                }
              />
              <div>
                <Label>{trans("filters.currency")} </Label>
                <Select
                  onValueChange={(val) => [
                    // setFilters({ ...filters, currency: val.slice(0, 3) }),
                    setCurrency(val),
                  ]}
                  value={currency as string}
                >
                  <SelectTrigger>
                    <SelectValue placeholder={trans("filters.currency")} />
                  </SelectTrigger>
                  <SelectContent>
                    {data?.info?.currencies.map((curr) => (
                      <SelectItem
                        key={curr?.id}
                        value={curr?.currency + curr?.id.toString()}
                      >
                        <div className="flex items-center gap-1">
                          <img src={curr?.image} alt="" className="h-4 w-4" />{" "}
                          <span>{curr?.currency}</span>
                        </div>
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </div>
              <div>
                <Label>{trans("filters.paymentMethods")} </Label>
                <Popover>
                  <div className=" grid ">
                    <PopoverTrigger asChild>
                      <Button
                        role="combobox"
                        className={cn(
                          "focus:outline-indigo-400 dark:focus:outline-grey-400 focus:outline-none dark:bg-grey-600 bg-input-field text-black dark:text-white dark:placeholder:text-gray-200 w-full border py-2"
                        )}
                      >
                        {isEmpty(paymentMethods) ? (
                          <span className="flex  w-full gap-2">
                            Select payment methods
                          </span>
                        ) : (
                          <span className="flex  w-full gap-2">
                            {`${paymentMethods?.length} Selected`}
                          </span>
                        )}
                        <ChevronDown className="ml-2 h-4 w-4 shrink-0 opacity-50 " />
                      </Button>
                    </PopoverTrigger>
                    <PopoverContent
                      className={cn(
                        ` max-h-[--radix-popover-content-available-height] overflow-y-scroll p-0 min-w-[var(--radix-popover-trigger-width)]  z-[100] `
                      )}
                      align="start"
                    >
                      <Command>
                        <CommandInput placeholder={`Search payments`} />
                        <CommandEmpty>Nothing found.</CommandEmpty>
                        <CommandGroup>
                          {data?.info?.payment_methods.map((item, index) => (
                            <CommandItem
                              key={index}
                              onSelect={() => {
                                if (
                                  paymentMethods &&
                                  paymentMethods?.length >= 1
                                ) {
                                  if (paymentMethods?.includes(item?.id)) {
                                    setPaymentMethods(
                                      (prev) =>
                                        prev?.filter(
                                          (i) => i !== item?.id
                                        ) as number[]
                                    );
                                  } else {
                                    setPaymentMethods((prev) => [
                                      ...(prev as number[]),
                                      item?.id,
                                    ]);
                                  }
                                } else {
                                  // setFilters((prev) => ({
                                  //   ...prev,
                                  //   ["payment_methods"]: [{ id: item?.id }],
                                  // }));
                                  setPaymentMethods([item?.id]);
                                }
                              }}
                              value={item?.name}
                            >
                              <Check
                                className={cn(
                                  "mr-2 h-4 w-4",
                                  paymentMethods?.some((i) => i === item?.id)
                                    ? "opacity-100"
                                    : "opacity-0"
                                )}
                              />

                              <div className="flex items-center h-1">
                                <span className="text-lg mr-2">
                                  <img
                                    src={item?.image}
                                    alt=""
                                    className="h-5 w-5"
                                  />
                                </span>
                                <span>{item?.name}</span>
                              </div>
                            </CommandItem>
                          ))}
                        </CommandGroup>
                      </Command>
                    </PopoverContent>
                  </div>
                </Popover>
              </div>
              <Button
                onClick={refresh}
                className="bg-[#F6F8FF] border border-gray-200 text-gray-500 flex items-center gap-1"
              >
                {trans("filters.clearFilters")}{" "}
                <RotateCw className="h-4 w-4 text-gray-500" />
              </Button>
            </div>
          </Modal>
        )}
      </Screen>
    </>
  );
};

export default P2pTrade;
